import { render } from "./MyScroll.vue?vue&type=template&id=616053dc"
import script from "./MyScroll.vue?vue&type=script&lang=js"
export * from "./MyScroll.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrian/vue/laolife/newlife-web-about/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__